export default () => window.location.hostname.includes('local');
//# sourceMappingURL=isLocal.js.map